import { createSlice, current, isDraft } from "@reduxjs/toolkit";

// v3: a szótárak mostantól stale-while-revalidate módon frissülnek, lásd
// services/dictionary.js. A v2-es cache lejárat nélkül élt, és a hook csak akkor
// töltött, ha a kulcs hiányzott — így a böngésző abban az állapotban ragadt, amikor
// először betöltötte az appot, és a később felvett cégek/irodák/címkék soha nem
// jelentek meg a legördülőkben. A verzióbumppal a beragadt cache-ek egyszer
// biztosan kiürülnek.
const STORAGE_KEY = "hcmd_dictionary_cache_v3";
const LEGACY_STORAGE_KEYS = [
  "hcmd_dictionary_cache",
  "hcmd_dictionary_cache_v2",
];

const emptyState = () => ({ store: {}, meta: {} });

const loadFromStorage = () => {
  try {
    LEGACY_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    const cached = localStorage.getItem(STORAGE_KEY);
    if (!cached) {
      return emptyState();
    }
    const parsed = JSON.parse(cached);
    return {
      store: parsed?.store ?? {},
      meta: parsed?.meta ?? {},
    };
  } catch {
    return emptyState();
  }
};

const persist = (state) => {
  try {
    const snapshot = isDraft(state) ? current(state) : state;
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ store: snapshot.store, meta: snapshot.meta })
    );
  } catch {
    // localStorage full or unavailable — silently ignore
  }
};

const initialState = loadFromStorage();

export const dictionarySlice = createSlice({
  name: "dictionary",
  initialState,
  reducers: {
    setDictionaryStore: (state, action) => {
      const { attr, items } = action.payload ?? {};
      if (!attr || !items) {
        return;
      }
      state.store = { ...state.store, [attr]: items };
      state.meta = { ...state.meta, [attr]: { fetchedAt: Date.now() } };
      persist(state);
    },
    // A szótár tartalmát meghagyjuk (nem villannak ki a legördülők), csak a
    // frissességét dobjuk el: a következő olvasáskor a háttérben újratöltődik.
    invalidateDictionary: (state, action) => {
      const attrs = action.payload?.attrs ?? [];
      if (!attrs.length) {
        return;
      }
      const meta = { ...state.meta };
      attrs.forEach((attr) => delete meta[attr]);
      state.meta = meta;
      persist(state);
    },
  },
});

export const { setDictionaryStore, invalidateDictionary } =
  dictionarySlice.actions;

export default dictionarySlice.reducer;
